import Unavailable from "@/components/Unavailable";

export default function Messages() {
  return (
    <div className="max-w-5xl mx-auto py-10">
      <div className="eyebrow">MESSAGES</div>
      <h1 data-testid="messages-title" className="font-display text-3xl mb-5">Vos conversations.</h1>
      <Unavailable
        testid="messages-unavailable"
        title="La messagerie ouvrira avec les premières séances."
        text="Une conversation se crée entre un joueur et son coach au moment de la réservation. Tant que les réservations ne sont pas ouvertes, il n'y a personne à qui écrire."
        note="Pour joindre l'équipe Perform, écrivez à support@performcustom.com."
      />
    </div>
  );
}
